var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 15.0007V34.989C35.0015 35.2079 34.96 35.4249 34.8776 35.6277C34.7953 35.8305 34.6738 36.0151 34.5201 36.1709C34.3664 36.3268 34.1836 36.4508 33.9819 36.536C33.7803 36.6212 33.5639 36.6658 33.345 36.6673H6.655C6.21636 36.6673 5.79565 36.4932 5.48533 36.1832C5.175 35.8732 5.00044 35.4526 5 35.014V4.98732C5 4.09232 5.745 3.33398 6.66333 3.33398H23.3333V13.334C23.3333 13.776 23.5089 14.1999 23.8215 14.5125C24.1341 14.8251 24.558 15.0007 25 15.0007H35ZM35 11.6673H26.6667V3.33898L35 11.6673ZM13.3333 11.6673V15.0007H18.3333V11.6673H13.3333ZM13.3333 18.334V21.6673H26.6667V18.334H13.3333ZM13.3333 25.0007V28.334H26.6667V25.0007H13.3333Z",
    fill: "#22428F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.4fc3d43c567cfe1121f1aeefe21e7a19.svg";
export { ForwardRef as ReactComponent };